import type { CommodityOption, UnitOfMeasureOption } from "./types";

export const getCommodityUnitOptions = (
  commodity: CommodityOption | undefined,
  units: UnitOfMeasureOption[]
): UnitOfMeasureOption[] => {
  if (!commodity) {
    return [];
  }
  return (commodity.units ?? [])
    .map(unitId => units.find(unit => unit.id === unitId))
    .filter((unit): unit is UnitOfMeasureOption => Boolean(unit));
};
